import React from 'react'

const ShoppingBagIcon: React.FC = (props) => (
	<svg
		{...props}
		version='1.1'
		id='Layer_1'
		xmlns='http://www.w3.org/2000/svg'
		xmlnsXlink='http://www.w3.org/1999/xlink'
		x='0px'
		y='0px'
		viewBox='0 0 64 64'
		enableBackground='new 0 0 64 64'
		xmlSpace='preserve'>
		<path
			fill='currentColor'
			d={`M57.5,57.3l-4.1-37c-0.3-3-2.9-5.3-6-5.3H43v-4c0-6-4.9-10.9-10.9-10.9C26,0.1,21.1,5,21.1,11v4h-5.6c-3.1,0-5.6,2.3-6,5.3
l-4.1,37C5.3,59,5.9,60.7,7,62s2.8,2,4.5,2h40.1c1.7,0,3.3-0.7,4.5-2S57.7,59,57.5,57.3z M25.1,11c0-3.8,3.1-6.9,6.9-6.9
S39,7.2,39,11v4H25.1V11z M53,59.3c-0.4,0.4-0.9,0.7-1.5,0.7H11.5c-0.6,0-1.1-0.2-1.5-0.7c-0.4-0.4-0.6-1-0.5-1.6l4.1-37
c0.1-1,1-1.8,2-1.8h5.6v3.4C19.3,23.1,18,24.9,18,27c0,2.8,2.2,5,5,5s5-2.2,5-5c0-2-1.2-3.7-2.9-4.5V19H39v3.4c-1.8,0.8-3,2.5-3,4.6
c0,2.8,2.2,5,5,5s5-2.2,5-5c0-2-1.2-3.8-3-4.6V19h4.4c1,0,1.9,0.8,2,1.8l4.1,37C53.6,58.4,53.4,58.9,53,59.3z M24,27
c0,0.6-0.4,1-1,1s-1-0.4-1-1s0.4-1,1-1S24,26.4,24,27z M42,27c0,0.6-0.4,1-1,1s-1-0.4-1-1s0.4-1,1-1S42,26.4,42,27z`}
		/>
	</svg>
)

export default ShoppingBagIcon
